export default __webpack_public_path__ + "static/media/stanWuPic.1854c57f.jpg";